import PropTypes from "prop-types";
import $ from "jquery";

import ChartkickChart from "../../../shared_components/chartkick_chart";

class GlobalVerticalChart extends ChartkickChart {
  customizeOptions(options, props) {
    // Safe to mutate, the actual prop is just a string so this wouldn't count as mutating a prop.
    const modifiedOptions = options;

    options.library.xAxis.labels.formatter = function () {
      let highlightedClass = "";
      if (this.value === this.axis.chart.userOptions.highlightValue) {
        highlightedClass = "highlighted";
      }

      const label = `<span class="x-axis-label ${highlightedClass}">${this.value}</span>`;
      return label;
    };

    if (props.highlightCountry) {
      options.library.highlightValue = props.highlightCountry;
    } else {
      options.library.highlightValue = null;
    }

    options.library.reOrderableChart = true;

    return modifiedOptions;
  }

  mutateChartBeforeRender(chart, nextProps) {
    if (nextProps.highlightCountry) {
      chart.userOptions.highlightValue = nextProps.highlightCountry;
    } else {
      chart.userOptions.highlightValue = null;
    }
  }

  // eslint-disable-next-line no-unused-vars
  mutateChartAfterRender(chart) {
    const $container = $(this.chartContainerWrapper.current);
    const $labelGroup = $container.find(".highcharts-axis-labels.highcharts-xaxis-labels");

    $labelGroup.on("click", ".x-axis-label", this.props.onChange);

    if (this.props.highlightCountry) {
      const $span = $labelGroup.find(".x-axis-label:contains('" + this.props.highlightCountry + "')");

      if ($span.length > 0) {
        const offsetTop = $span.offset().top;

        const containerOffsetTop = $container.offset().top;
        const containerScollTop = $container.scrollTop();

        $container.scrollTop((offsetTop - containerOffsetTop) + containerScollTop - 200);

        $labelGroup.addClass("label-highlighted");
      } else {
        $container.scrollTop(0);
        $labelGroup.removeClass("label-highlighted");
      }
    } else {
      $container.scrollTop(0);
      $labelGroup.removeClass("label-highlighted");
    }

    chart.redraw();
  }

  containerStyles() {
    return {
      height: "calc(100% - 70px)",
      overflow: "auto",
      position: "relative"
    };
  }

  enableAddToSlideDeck() {
    return false;
  }
}

GlobalVerticalChart.propTypes = Object.assign({}, ChartkickChart.propTypes, {
  highlightCountry: PropTypes.string,
  onChange: PropTypes.func.isRequired
});

export default GlobalVerticalChart;
